import { Typography, TypographyProps } from '@mui/material';

export const PopupTitle = (props: TypographyProps) => {
    return (
        <Typography
            {...props}
            sx={{
                fontWeight: 'medium',
                fontSize: '30px',
                color: '#533D18',
                ...props.sx,
            }}>
            {props.children}
        </Typography>
    );
};
